import { createApp } from 'vue';
import { createPinia } from 'pinia';
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
// ⚠️ 必须排在 element-plus 的样式之后: 里面是主色与基础样式的覆盖
import './styles/theme.css';
// 组件库默认是英文（分页 "Total"、表格 "No Data"），统一成中文
import zhCn from 'element-plus/es/locale/lang/zh-cn';
import App from './App.vue';
import { router } from './router';

const app = createApp(App);
app.use(createPinia());
app.use(router);
app.use(ElementPlus, { locale: zhCn });
app.mount('#app');
